export class ErrorDialogModel {
  public summary: string;
  public detail: string;
  public severity: string;
  public id: string;
  public errorStatus: number;
  
}
